module.exports = __webpack_public_path__ + "img/content3-3.c0a264b3.webp";